import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const MailNurture = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M7.22858 10.2576C7.3264 9.97359 7.66189 9.83049 7.94873 9.96981C15.313 13.5466 21.9906 14.4451 29.9416 14.4995C30.3139 14.5021 30.5554 14.8843 30.4077 15.2136L24.5922 28.1792C24.499 28.3871 24.2774 28.5044 24.0558 28.4657C15.7655 27.0156 10.5175 25.1508 3.92801 20.9985C3.73735 20.8784 3.65278 20.6401 3.72813 20.4213L7.22858 10.2576Z"
          fill="#FB6434"
          stroke="#2B2F38"
        />
        <path
          d="M5.10986 9.7218C5.16066 9.4336 5.45801 9.23831 5.76218 9.31781C13.6869 11.3892 19.8949 10.3254 27.6521 8.77967C28.0002 8.7103 28.3071 9.01343 28.244 9.35969L25.575 24.0055C25.5323 24.2395 25.3323 24.4078 25.1009 24.411C16.7256 24.5283 10.9391 23.0934 3.65776 20.2369L3.47515 20.7024L3.65776 20.2369C3.44026 20.1516 3.31164 19.9232 3.35286 19.6894L5.10986 9.7218Z"
          fill="#F8B200"
          stroke="#2B2F38"
        />
        <path
          d="M2.67005 9.58733C2.65009 9.29474 2.89281 9.03567 3.20439 9.04246C11.2599 9.21811 15.8561 7.36171 22.9018 4.05184C23.2083 3.90784 23.5646 4.10018 23.614 4.42932L25.7339 18.5459C25.7717 18.7975 25.6152 19.0329 25.3762 19.0954C17.37 21.1883 11.4623 21.1739 3.78519 20.1427C3.55409 20.1117 3.37498 19.9211 3.35885 19.6846L2.67005 9.58733Z"
          fill="#FFDB59"
          stroke="#2B2F38"
        />
        <path
          d="M2.95973 11.2432C6.37823 13.6487 9.76443 15.7543 13.3802 17.6014C13.7498 17.7902 14.1987 17.7265 14.5005 17.4415C18.0217 14.1174 20.4194 10.9729 23.6991 6.32815"
          stroke="#2B2F38"
        />
      </svg>
    )
  },
)

export default MailNurture
